export default {
  /** 图标名称 **/
  name: {
    type: String,
    default: "",
    required: true,
  },
};
